/* eslint-disable */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { assetImages } from "constants";

import { placeholderCount } from "Config/Config";

import * as url from "helper/UrlHelper";

const CommunityLeftPanel = ({
  isLoading,
  forumList,
  setforumId,
  onNextPage,
  totalRecords,
  setTagFourmId,
  filterQuery,
}) => {
  const token = localStorage.getItem("token");

  return (
    <div className="col-lg-5">
      <div className="srch_results_text">
        <h5 className="text-black fs-sm mb-3">
          {filterQuery != "" ? `Searching "${filterQuery}"` : ""} result{" "}
          <strong>{forumList.length}</strong>
        </h5>
      </div>
      <div className="activity_leftpnl">
        {isLoading
          ? placeholderCount.map((item, index) => {
              return (
                <div
                  className="activity_lftItem py-4 mb-3 rounded-16"
                  key={index}
                >
                  <div className="glow_area list_glowArea">
                    <div className="user_placeHoledr d-flex align-items-center gap-3 mb-4">
                      <div
                        className="default_usr placeholder rounded-circle"
                        style={{
                          height: "30px",
                          width: "30px",
                          minWidth: "30px",
                        }}
                      >
                        <img src="images/default-user.png" alt="" />
                      </div>
                      <div
                        className="default_usr_name"
                        style={{ width: "200px" }}
                      >
                        <span className="placeholder placeholder-sm d-block rounded-3"></span>
                      </div>
                    </div>
                    <div className="plan rounded-3 placeholder-glow">
                      <span className="placeholder placeholder-sm col-12 rounded-3 mb-3"></span>
                      <span className="placeholder placeholder-sm col-10 rounded-3 mb-4"></span>

                      <div className="data_btnOuter">
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                        <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : forumList.map((forumData, index) => {
              return (
                <div
                  className="activity_lftItem py-4 mb-3 rounded-16"
                  key={index}
                >
                  <div className="option_drops_activity d-flex align-items-center justify-content-between mb-3">
                    <div className="activity_userOuter d-flex align-items-center gap-2">
                      <div className="activity_usrPnl d-flex align-items-center gap-2">
                        <div className="user_activty rounded-circle overflow-hidden">
                          <img
                            src={
                              forumData.moderatorimage == ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + forumData.moderatorimage
                            }
                            alt=""
                          />
                        </div>
                        <div className="activty_usrname">
                          <h4 className="text-black fs-md fw-bold">
                            {forumData.moderatorname}
                          </h4>
                        </div>
                      </div>
                      <div className="activity_date d-flex align-items-center gap-2 fs-sm text-black">
                        <span>
                          {forumData.timestring}
                          {/* <span>17:31</span> */}
                        </span>
                      </div>
                    </div>
                    <div className="more_option dropdown">
                      <Link to="#" data-bs-toggle="dropdown">
                        <span className="d-block material-icons-outlined text-black">
                          more_vert
                        </span>
                      </Link>
                      <ul className="list_style_none dropdown-menu">
                        <li>
                          <Link
                            to="#"
                            onClick={() => {
                              setforumId(forumData._id);
                              document.body.classList.add("activity_open");
                            }}
                          >
                            View Post
                          </Link>
                        </li>
                        {/* <li>
                          <Link
                            to="#"
                            onClick={() => {
                              setforumId(forumData._id);
                            }}
                          >
                            Delete Post
                          </Link>
                        </li> */}
                        {/* {token && (
                          <li>
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#addtag_mdl"
                              onClick={() => {
                                setTagFourmId(forumData._id);
                              }}
                            >
                              Add Tag
                            </Link>
                          </li>
                        )} */}
                      </ul>
                    </div>
                  </div>

                  <div className="activty_lftHdng mb-2">
                    <Link
                      to="#"
                      onClick={() => {
                        setforumId(forumData._id);
                        document.body.classList.add("activity_open");
                      }}
                      className="text-primary fw-bold fs-lg"
                    >
                      {forumData.title}
                    </Link>
                  </div>

                  <div className="winers_likeOuter d-flex align-items-center mt-3 mb-3 gap-2 flex-wrap">
                    <div className="action d-flex align-items-center gap-2">
                      <Link
                        to="#"
                        className="btn white_btn text-black px-3 py-2 d-inline-flex align-items-center gap-2 rounded-4"
                      >
                        <span className="d-block material-icons-outlined fs-lg">
                          thumb_up
                        </span>
                        <span className="d-block">Likes</span>
                        <span
                          className="d-flex align-items-center justify-content-center bg-pink text-white rounded-90"
                          style={{
                            minWidth: "1.325rem",
                            height: "1.4rem",
                          }}
                        >
                          {forumData.likes.length}
                        </span>
                      </Link>
                      <Link
                        to="#"
                        className="btn white_btn text-black px-3 py-2 d-inline-flex align-items-center gap-2 rounded-4"
                      >
                        <span className="d-block material-icons-outlined fs-lg">
                          comment
                        </span>
                        <span className="d-block">comment</span>
                        <span
                          className="d-flex align-items-center justify-content-center bg-pink text-white rounded-90"
                          style={{
                            minWidth: "1.325rem",
                            height: "1.4rem",
                          }}
                        >
                          {forumData.commentlist.length}
                        </span>
                      </Link>
                    </div>
                    <div className="winner_tags btn d-inline-flex align-items-center gap-2 justify-content-center primary-btn px-3 py-2 rounded-4 overflow-hidden">
                      <i className="material-icons-outlined fs-lg">verified</i>
                      <span>Winner</span>
                    </div>
                  </div>
                  <div className="activity_tagsouter">
                    {forumData.taglistarr.length > 0 ? (
                      <div className="activity_tagsRow mb-3">
                        <h4 className="text-black fs-sm fw-bold mb-2">Tags</h4>
                        <div className="experts_skill activity_skill d-flex gap-2">
                          <ul className="list_style_none d-flex align-items-center gap-2 flex-wrap">
                            {forumData.taglistarr
                              .slice(0, 4)
                              .map((tag, index) => {
                                return (
                                  <li key={index}>
                                    <Link
                                      to="#"
                                      className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                                    >
                                      {tag.title}
                                    </Link>
                                  </li>
                                );
                              })}
                          </ul>
                          {forumData.taglistarr.length > 4 ? (
                            <div className="more_tags">
                              <Link
                                to="#"
                                className="d-flex align-items-center py-2 px-3 text-black rounded-4 fs-sm"
                              >
                                +{forumData.taglistarr.length - 4}
                              </Link>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}

                    {/* <div className="activity_tagsRow">
                      <h4 className="text-black fs-sm fw-bold mb-2">
                        Categories{" "}
                      </h4>
                      <div className="experts_skill activity_skill d-flex  gap-2">
                        <ul className="list_style_none d-flex align-items-center gap-2 flex-wrap">
                          <li>
                            <Link
                              to="#"
                              className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                            >
                              Backend
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                            >
                              Data analyst
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                            >
                              Data
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                            >
                              Load
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                            >
                              Data science
                            </Link>
                          </li>
                        </ul>
                        <div className="more_tags">
                          <Link
                            to="#"
                            className="d-flex align-items-center py-2 px-3 text-black rounded-4 fs-sm"
                          >
                            +4
                          </Link>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              );
            })}
      </div>

      {totalRecords === forumList.length ? (
        <div className="activity_lftItem py-4 mb-3 rounded-16 no_post">
          <h5 className="text-primary-gray fs-md text-center">
            {" "}
            No more post to display
          </h5>
        </div>
      ) : null}

      {/* pagination */}
      {forumList.length == 0 ? null : totalRecords ===
        forumList.length ? null : (
        <div className="load_more mt-5 text-center">
          <Link
            to="#"
            className="btn primary-btn"
            onClick={() => {
              onNextPage();
            }}
          >
            load more
          </Link>
        </div>
      )}
    </div>
  );
};

export default CommunityLeftPanel;
